export default "__VITE_ASSET__DTcU6yaT__"